import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  API_URL = `${environment.apiUrl}/template`;

  private readonly blobHeaders = {
    Accept: 'application/octet-stream, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  };

  constructor(private http: HttpClient) {}

  downloadPorjectTemplate(): Observable<Blob> {
    return this.http.get(`${this.API_URL}/project-template`, {
      responseType: 'blob',
      headers: this.blobHeaders,
    });
  }

  downloadEmployeeTemplate(): Observable<Blob> {
    return this.http.get(`${this.API_URL}/employee-template`, {
      responseType: 'blob',
      headers: this.blobHeaders,
    });
  }

  downloadActivityTemplate(): Observable<Blob> {
    return this.http.get(`${this.API_URL}/activity-template`, {
      responseType: 'blob',
      headers: this.blobHeaders,
    });
  }

  downloadClientTemplate(): Observable<Blob> {
    return this.http.get(`${this.API_URL}/client-template`, {
      responseType: 'blob',
      headers: this.blobHeaders,
    });
  }
  downloadStuffedRoleTemplate(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/import-data/download-stuffed-role-template`, {
      responseType: 'blob',
      headers: this.blobHeaders,
    });
  }
}
